import { api } from "@lib/orpc-client"
import useSWR from "swr"

type OngoingTransactionInformation = {
    hasOngoingTransaction: boolean
    canCreateNewTransaction: boolean
}

const useOngoingTransaction = () => {
    const { data, isLoading, error, isValidating } = useSWR(
        'wallet.ongoingTransaction',
        () => api.wallet.ongoingTransaction({}),
        {
            revalidateIfStale: true,
            revalidateOnFocus: true,
            revalidateOnReconnect: true,
            revalidateOnMount: true,
            refreshWhenHidden: true,
            refreshWhenOffline: true,
        }
    )
    return {
        data: data as OngoingTransactionInformation | undefined,
        isLoading: isLoading || isValidating,
        error
    }
}

export default useOngoingTransaction
